if (!customElements.get('products-toolbar')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.filtersComponent = document.querySelector('facet-filters');
      this.filtersColumn = document.querySelector('.main-products-grid__filters');
      this.sortBy = this.querySelector('.products-toolbar__sort');
      this.layoutSwitcher = this.querySelector('.products-toolbar__layout');

      if (this.filtersColumn) {
        this.filterToggle = this.querySelector('.js-toggle-filters');
        if (this.filterToggle) {
          this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
        }
      }

      //  sticky filter button
      this.stickyFilterBtn = document.querySelector('.products-toolbar__sticky-btn');
      if (this.stickyFilterBtn && this.filtersComponent) {
        this.stickyFilterBtn.addEventListener('click', this.toggleFilters.bind(this));
        // filter count number
        this.styleFilterCount();
        // Re-style when filters are updated
        document.addEventListener('on:facet-filters:updated', () => {
          setTimeout(() => {
            this.stickyFilterBtn = document.querySelector('.products-toolbar__sticky-btn');
            this.filterToggle = this.querySelector('.js-toggle-filters') || document.querySelector('.products-toolbar__filter-btn.js-toggle-filters');
            this.styleFilterCount();
          }, 150);
        });
      }
      if (this.filterToggle && this.filtersComponent && !this.stickyFilterBtn) {
        this.styleFilterCount();
        document.addEventListener('on:facet-filters:updated', () => {
          setTimeout(() => {
            this.filterToggle = this.querySelector('.js-toggle-filters') || document.querySelector('.products-toolbar__filter-btn.js-toggle-filters');
            this.styleFilterCount();
          }, 150);
        });
      }

      // Move sticky wrapper to body so position:fixed works on all devices (same as desktop)
      const moveStickyToBody = () => {
        const wrapper = document.querySelector('.products-toolbar__sticky-wrapper');
        if (wrapper && document.body && wrapper.parentElement && !wrapper.parentElement.isSameNode(document.body)) {
          document.body.appendChild(wrapper);
        }
      };
      [0, 100, 300].forEach(function (delay) {
        if (delay === 0) {
          moveStickyToBody();
        } else {
          setTimeout(moveStickyToBody, delay);
        }
      });
      window.addEventListener('load', moveStickyToBody);

      //  scroll detection for sticky button
      this.initStickyScrollDetection();

      if (!this.filtersComponent && this.sortBy) {
        this.sortBy.addEventListener('change', ProductsToolbar.handleSortByChange);
      }

      if (this.layoutSwitcher) {
        this.productsGrid = document.querySelector('.main-products-grid');

        this.layoutSwitcher.addEventListener('change', this.handleLayoutChange.bind(this));
        this.handleBreakpointChangeListener = this.handleBreakpointChange.bind(this);
        window.addEventListener('on:breakpoint-change', this.handleBreakpointChangeListener);

        this.applySelectedLayout();
      }
    }

    disconnectedCallback() {
      if (this.layoutSwitcher) {
        window.removeEventListener('on:breakpoint-change', this.handleBreakpointChangeListener);
      }
    }

    /**
     * Toggles open/closed state of the filters on desktop.
     */
    toggleFilters(evt) {
      const button = evt?.currentTarget || this.filterToggle;
      
      if (!this.filtersComponent) return;
      
      
      const isCurrentlyOpen = this.filtersComponent.getAttribute('aria-hidden') === 'false' || 
                              this.filtersComponent.hasAttribute('open');
      
      if (isCurrentlyOpen) {
      
        this.filtersComponent.close();
        
        // Update button states
        if (this.filterToggle) {
          this.filterToggle.classList.remove('is-active');
          this.filterToggle.setAttribute('aria-expanded', 'false');
        }
        if (this.stickyFilterBtn) {
          this.stickyFilterBtn.classList.remove('is-active');
          this.stickyFilterBtn.setAttribute('aria-expanded', 'false');
        }
        this.filtersOpen = false;
      } else {
        // Open the drawer
        this.filtersComponent.open(button);
        
        // Update button states
        if (this.filterToggle) {
          this.filterToggle.classList.add('is-active');
          this.filterToggle.setAttribute('aria-expanded', 'true');
        }
        if (this.stickyFilterBtn) {
          this.stickyFilterBtn.classList.add('is-active');
          this.stickyFilterBtn.setAttribute('aria-expanded', 'true');
        }
        this.filtersOpen = true;
      }
    }

    /**
     * Style the filter count number in the sticky button and mobile filter button
     */
    styleFilterCount() {
      const regularFilterBtn = this.filterToggle || document.querySelector('.products-toolbar__filter-btn.js-toggle-filters');
      const stickyFilterBtn = this.stickyFilterBtn;

      let buttonText = '';
      if (regularFilterBtn) {
        buttonText = regularFilterBtn.textContent.trim();
      } else if (stickyFilterBtn) {
        buttonText = stickyFilterBtn.textContent.trim();
      }
      if (!buttonText) return;

      const match = buttonText.match(/\((\d+)\)/);
      const newText = match
        ? buttonText.replace(/\((\d+)\)/, `<span class="search-filter-dialog_filtersCount__nGXUs">${match[1]}</span>`)
        : buttonText;

      if (stickyFilterBtn) {
        const stickyIcon = stickyFilterBtn.querySelector('.icon_iconContainer__lS_O1');
        const stickyIconHTML = stickyIcon ? stickyIcon.outerHTML : '';
        stickyFilterBtn.innerHTML = stickyIconHTML + newText;
      }

      if (regularFilterBtn && regularFilterBtn !== stickyFilterBtn) {
        const mobileIcon = regularFilterBtn.querySelector('.icon_iconContainer__lS_O1');
        const mobileIconHTML = mobileIcon ? mobileIcon.outerHTML : '';
        regularFilterBtn.innerHTML = mobileIconHTML + newText;
      }
    }

    /**
     *  scroll detection for sticky button visibility
     */
    initStickyScrollDetection() {
      const stickyWrapper = document.querySelector('.products-toolbar__sticky-wrapper');
      const productsGrid = document.querySelector('custom-pagination.main-products-grid');
      
      if (!stickyWrapper || !productsGrid) return;

      const handleScroll = () => {
        const productsGridRect = productsGrid.getBoundingClientRect();
        const productsGridBottom = productsGridRect.bottom;
        if (productsGridBottom <= 0) {
          stickyWrapper.classList.add('is-hidden');
        } else {
          stickyWrapper.classList.remove('is-hidden');
        }
      };

    
      handleScroll();
      
     
      let ticking = false;
      const scrollHandler = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      };
      
      window.addEventListener('scroll', scrollHandler, { passive: true });
      window.addEventListener('resize', handleScroll, { passive: true });
    }

    /**
     * Handles 'change' events on the layout switcher buttons.
     * @param {object} evt - Event object.
     */
    handleLayoutChange(evt) {
      const layoutColumns = this.currentColumns;

      if (theme.mediaMatches.lg) {
        this.productsGrid.dataset.columnsLg = evt.target.value;
        layoutColumns.lg = evt.target.value;
      } else if (theme.mediaMatches.md) {
        this.productsGrid.dataset.columnsMd = evt.target.value;
        layoutColumns.md = evt.target.value;
      } else if (theme.mediaMatches.sm) {
        this.productsGrid.dataset.columnsSm = evt.target.value;
        layoutColumns.sm = evt.target.value;
      } else if (!theme.mediaMatches.sm) {
        this.productsGrid.dataset.columnsMobile = evt.target.value;
        layoutColumns.mobile = evt.target.value;
      }

      try {
        const persistedColumns = JSON.stringify(layoutColumns);
        sessionStorage.setItem('cc-products-layout', persistedColumns);
      } catch (e) {
        //
      }
    }

    /**
     * Handles when a sort by dropdown is changed (and filtering is disabled)
     * @param {object} evt - Event object.
     */
    static handleSortByChange(evt) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', evt.detail.selectedValue);
      urlObj.hash = 'products-toolbar';
      window.location.href = urlObj.toString();
    }

    /**
     * Applies the users layout switcher selection.
     */
    applySelectedLayout() {
      const persistedColumns = sessionStorage.getItem('cc-products-layout');
      if (!persistedColumns) return;

      try {
        const layoutColumns = JSON.parse(persistedColumns);

        this.productsGrid.dataset.columnsLg = layoutColumns.lg;
        this.productsGrid.dataset.columnsMd = layoutColumns.md;
        this.productsGrid.dataset.columnsSm = layoutColumns.sm;
        this.productsGrid.dataset.columnsMobile = layoutColumns.mobile;

        this.updateSelectedLayoutOption();
      } catch (e) {
        //
      }
    }

    /**
     * Handles 'change' events when the breakpoint of the viewport changes.
     */
    handleBreakpointChange() {
      this.updateSelectedLayoutOption();
    }

    /**
     * Sets the selected layout switcher input.
     */
    updateSelectedLayoutOption() {
      const layoutColumns = this.currentColumns;
      let selectedValue;

      if (theme.mediaMatches.lg) {
        selectedValue = layoutColumns.lg;
      } else if (theme.mediaMatches.md) {
        selectedValue = layoutColumns.md;
      } else if (theme.mediaMatches.sm) {
        selectedValue = layoutColumns.sm;
      } else if (!theme.mediaMatches.sm) {
        selectedValue = layoutColumns.mobile;
      }

      const options = Array.from(this.layoutSwitcher.querySelectorAll('input[name="products-layout"]'));
      options.forEach((option) => {
        option.checked = (option.value === selectedValue);
      });
    }

    /**
     * Get the current column data attributes from the DOM.
     * @returns {object} Object containing the current columns for each breakpoint.
     */
    get currentColumns() {
      return {
        mobile: this.productsGrid.dataset.columnsMobile,
        sm: this.productsGrid.dataset.columnsSm,
        md: this.productsGrid.dataset.columnsMd,
        lg: this.productsGrid.dataset.columnsLg
      };
    }
  }

  customElements.define('products-toolbar', ProductsToolbar);
}
